<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.page_heading" [ttModel]="setting.page_heading"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-3 p-5">
        <tt-select ttRememberId="w_orderlinecredits.orderlinecredits_selection_id" ttLabel="orderlinecredits_selection" [(ttModel)]="setting.orderlinecredits_selection_id" (ttModelChange)="onChanged($event, 'orderlinecredits_selection_id')" [ttData]="selectListSelectionIds" ttDataId="orderlinecredits_selection_id" ttDataName="orderlinecredits_selection_name"></tt-select>
    </tt-card>

    <tt-grid *ngIf="!!grid" class="flex-1 p-5" [(ttOptions)]="grid"></tt-grid>
</tt-page>
